import { Icon } from '@bamboohr/fabric';

export function PageHeaderIcon({ icon }) {
	if (typeof icon === 'function') {
		return icon();
	}
	return (<Icon name={ icon } />);
}
